export const DiscountTypeEnum = {
    cash: 'cash',
    percentage: 'percentage'
};
